export default {
  actions: {
    warning: 'Advertencia',
    search_fotograms: 'Consulta de fotogramas',
    tools: 'Herramientas para seleccionar fotogramas',
    view_extend: 'Extensión de la vista',
    polygons: 'Selección por polígono',
    mtn_sheet: 'Selección por Hoja del MTN',
    remove_criteria: 'Eliminar criterio de selección',
    load_selection: 'Cargar selección',
    available_scale_1: 'Esta herramienta se habilita a una escala',
    available_scale_2: 'o de mayor detalle (nivel de provincia).',
    sheet_not_found: 'Hoja no encontrada, revise la consulta.',
    select_flight: 'Esta herramienta se habilita cuando se selecciona algún vuelo.',
    using_geometry: 'Selección usando geometría en fichero local',
    allowed_formats: 'Archivo con el área de selección (.shp comprimido en .zip, .kml, .gpx o .geojson).',
    srs: 'El Sistema de Referencia del archivo se adaptará al del visor.',
  },
  checkbox: {
    select: 'Seleccionar',
    quit: 'Quitar selección',
  },
  download: {
    name: 'Nombre',
    surname: 'Apellidos',
    organization: 'Organización',
    zip_code: 'Código Postal',
    email: 'Correo electrónico',
    more_quality: `Si necesita los fotogramas en alta calidad, por favor solicítela <b class='clickable'>aquí.</b>`,
    terms_and_conditions: 'Términos y condiciones',
    next: 'Siguiente',
    one_by_one: `Haga click en los siguientes enlaces para <b>descargar los ficheros uno a uno:</b>`,
    text_metalink: `Usando el botón <a target='_blank' rel='noopener noreferrer' href='https://es.wikipedia.org/wiki/Metalink'>metalink</a>, puede descargar todos los ficheros con un solo click usando un <a target='_blank' rel='noopener noreferrer' href='http://www.metalinker.org/implementation.html'>gestor de descargas compatible</a>`,
    metalink: 'Metalink',
  },
  filters: {
    search_flights: 'Búsqueda de vuelos',
    text: 'Texto a buscar',
    flight_type: 'Tipo de vuelo',
    select: 'Seleccionar',
    date: 'Se voló entre',
    search: 'Buscar',
    clean: 'Limpiar',
    please: 'Por favor, introduzca algún criterio de búsqueda.',
    check: 'Comprueba que la escala y el año de vuelo están en el formato correcto.',
    regional: 'Regional',
    infrastructures: 'Infraestructuras',
    inside_view: 'Dentro de la vista actual',
    back: 'Volver',
    and: 'y',
    load_error: 'No se han podido cargar los datos. Por favor, inténtelo de nuevo en unos minutos y si el error persiste contacte con nosotros.',
    all_types: 'Todos los tipos',
    all_typologies: 'Todas las tipologías',
    analogic: 'Analógico',
    digital: 'Digital',
    typology: 'Tipología',
    colour: 'Color',
    all_colors: 'Todos los colores',
    select_range: 'Selecciona el rango de años sobre los que realizar la búsqueda. El segundo año tendrá que ser posterior al primero.',
  },
  info: {
    fotogram: 'Fotograma',
    flight: 'Vuelo',
    flight_id: 'Identificador',
    name: 'Nombre',
    date_flight: 'Se voló en',
    scale: 'Escala',
    registers_number: 'Número de registros',
    color: 'Color',
    fotogram_id: 'Identificador',
    date: 'Fecha',
    ellipsoid: 'Elipsoide',
    municipality: 'Municipio',
    zone: 'Huso',
    flight_type: 'Tipo de vuelo',
    flight_typologoy: 'Tipología de vuelo',
    province: 'Provincia',
    sheet_50: 'Hoja MTN50',
    sheet_25: 'Hoja MTN25',
    sheet_05: 'Hoja MTN05',
    download: 'Descargar',
    type: 'Tipo',
    typology: 'Tipología',
  },
  list: {
    my_list: 'Mi lista de fotogramas',
    fotograms: 'Fotogramas',
    opacity: 'Opacidad',
    actions: 'Acciones',
    selected: 'Fotogramas seleccionados',
    remove: 'Borrar',
    download: 'Descargar',
    info: 'Información del Fotograma',
    please_wait: 'Por favor, espere...',
    not_area: 'No existe fotograma en el área seleccionada',
    download_fotograms: 'Descarga de cartografía',
    compare: 'Comparar',
    compare_fotograms: 'Comparación de fotogramas',
    flight: 'Vuelo',
    fotogram: 'Fotograma',
    error: 'Ocurrió un error realizando la impresión. Por favor, inténtelo de nuevo en unos minutos y si el error persiste contacte con nosotros.',
    download_error: 'Ocurrió un error generando los links de descarga. Por favor, inténtelo de nuevo en unos minutos y si el error persiste contacte con nosotros.',
    info_error: 'Ocurrió un error consultando los metadatos del fotograma. Por favor, inténtelo de nuevo en unos minutos y si el error persiste contacte con nosotros.',
  },
  menu: {
    search_on_view: 'Buscar fotogramas',
    close: 'Cerrar',
  },
  mtnSelector: {
    grid: 'Cuadrícula',
    number: 'Número',
    quarter: 'Cuarto',
    show_sheet: 'Mostrar Hoja',
    number_50: 'Número de Hoja del MTN50',
  },
  pagination: {
    of: ' de ',
  },
  printSelection: {
    info: 'Información',
    step1: '1. Haz click en el recuadro.',
    step2: '2. Arrastra el recuadro a la zona.',
    step3: '3. Suelta el recuadro.',
    paper: 'Papel',
    scale: 'Escala',
    custom: 'Personalizada',
    orientation: 'Orientación',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    request_certificate: 'Solicitar Certificado',
    digital: 'Digital',
    accept: 'Aceptar',
    certificate_text: 'Se enviará el documento impreso con la zona que seleccione. Este certificado tiene un coste de servicio que una vez añadido al carrito, se gestionará en la Tienda Virtual. Seleccione el carrito para ver su pedido.',
  },
  results: {
    search_data: 'Consultar metadatos',
    results: 'Resultados',
    name: 'Nombre',
    type: 'Tipo',
    actions: 'Acciones',
    flight_info: 'Información del Vuelo',
    select: 'Seleccionar',
    code: 'Código',
    typology: 'Tipología',
    to_zoom: 'Ir a la extensión',
  },
  tableRow: {
    fotogram: 'Fotograma',
    flight: 'Vuelo',
    show: 'Mostrar',
    hide: 'Ocultar',
    info: 'Consultar datos',
    certify: 'Certificar',
    delete: 'Eliminar',
  },
  visor: {
    wrong_format: 'Ha introducido un archivo con un formato no válido.',
    no_geom: 'No se han detectado geometrías en este fichero.',
    max_allowed1: 'No se admiten ficheros con más de',
    max_allowed2: 'geometrías distintas.',
    area_limit: 'El área de consulta supera el límite permitido.',
    error_loading: 'Error al cargar el fichero. Compruebe que se trata del fichero correcto.',
    file: 'Fichero',
    aprox_position: 'posición aproximada',
    photo: 'Foto',
    sheet: 'Hoja MTN50',
    flight: 'Vuelo',
    date: 'Fecha',
    tools_panel: 'Panel de herramientas',
    lengths: 'Medir distancias',
    areas: 'Medir áreas',
    delete_measures: 'Borrar medidas',
    information: 'Consultar capas',
    rotate: 'Cambiar orientación del visor',
    scaleline: 'Línea de escala',
  },
  tree: {
    search: 'Buscar',
    type_here: 'Escribe aquí...',
    clear: 'Limpiar',
    please_characters: 'Por favor, introduce al menos 3 caracteres para realizar una búsqueda',
  },
};
